import { render, staticRenderFns } from "./productTable.vue?vue&type=template&id=61514e68&scoped=true&"
import script from "./productTable.vue?vue&type=script&lang=js&"
export * from "./productTable.vue?vue&type=script&lang=js&"
import style0 from "./productTable.vue?vue&type=style&index=0&id=61514e68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61514e68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61514e68')) {
      api.createRecord('61514e68', component.options)
    } else {
      api.reload('61514e68', component.options)
    }
    module.hot.accept("./productTable.vue?vue&type=template&id=61514e68&scoped=true&", function () {
      api.rerender('61514e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_order/components/productTable.vue"
export default component.exports